import { useTranslation } from "react-i18next";
import { PageTitleSection } from "../../../../common/components/PageTitleSection/PageTitleSection";
import { AnnualIncomeBreakdown } from "./AnnualIncomeBreakdown/AnnualIncomeBreakdown";
import defaultContent from "../../../../content/performanceIncomeDashboard";
import "./AnnualPerformanceIncome.scss";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store";
import { SELECTOR_TYPE, updateSelectorType } from "../../../../reducers/period";
import { HatLegsTrackingTile } from "./HatGarTile/HatLegsTrackingTile";
import { FaaTrackingTile } from "./FaaTrackingTile/FaaTrackingTile";
import { LeadershipTripQualTile } from "./LeadershipTripQualTile/LeadershipTripQualTile";
import { LeadershipSeminarPathViewTile } from "./LeadershipTripQualTile/LeadershipSeminarPathViewTile";
import { InMarketPinTrackingTile } from "./InMarketPinTrackingTile/InMarketPinTrackingTile";
import { AWARD_CODES } from "../../../../common/enums/award-codes";
import { FetchHatGarData } from "./HatGarTile/HatGarDataLayer";
import { useIsLSPathView } from "../../../LeadershipSeminar/Components/LSPathView";
import type { EligibleIncentive } from "../../../../services/MyBizShell/mybizShellAPI.types";

export const AnnualPerformanceIncome = () => {
  const { t } = useTranslation(["performanceIncomeDashboard", "common", "awardLabels", "badgeLegend", "hat"]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateSelectorType(SELECTOR_TYPE.PY));
  }, [dispatch]);

  const shellConfig = useAppSelector((state) => state.boot.shellConfig);
  const selectedPeriod = useAppSelector((state) => state.period.selectedPeriod);
  const hasLeadershipSeminar = shellConfig.eligibleIncentives.find(
    (i: EligibleIncentive) => i.awardNumber === AWARD_CODES.LSI,
  );
  // JP (and any future path-view market) displays the path view overview default path
  // instead of the standard leadership-trip-qual tile.
  const isLSPathView = useIsLSPathView();

  // Fetch HAT/GAR data once and share between tiles
  const hatGarDataFetch = FetchHatGarData(selectedPeriod);

  return (
    <div className="AnnualPerformanceIncome" data-testid="annual-performance-income">
      <div className="AnnualPerformanceIncome__heading">
        <div className="AnnualPerformanceIncome__heading-row">
          <PageTitleSection title={`${t("performance.title", defaultContent.performance.title as string)}`} />
        </div>
      </div>
      <div className="AnnualPerformanceIncome__content">
        <section className="AnnualPerformanceIncome__section AnnualPerformanceIncome__section-content">
          {hasLeadershipSeminar && (isLSPathView ? <LeadershipSeminarPathViewTile /> : <LeadershipTripQualTile />)}
          <InMarketPinTrackingTile
            hatGarData={hatGarDataFetch.hatGarData}
            isLoading={hatGarDataFetch.isLoading}
            errorStatus={hatGarDataFetch.errorStatus}
            refetch={hatGarDataFetch.refetch}
          />
          <HatLegsTrackingTile
            hatGarData={hatGarDataFetch.hatGarData}
            isLoading={hatGarDataFetch.isLoading}
            errorStatus={hatGarDataFetch.errorStatus}
            refetch={hatGarDataFetch.refetch}
          />
          <FaaTrackingTile />
        </section>

        <section>
          <AnnualIncomeBreakdown />
        </section>
      </div>
    </div>
  );
};
